import { IPayload } from 'models/Global'
import {
  IGetScreeningDocumentsParams,
  IPostScreeningDocumentParams,
  IScreeningDocument,
  IPutScreeningDocumentParams,
} from '@src/models/ScreeningDocument'
import { AxiosService } from '../config/config'
import { Endpoints } from '../config/endpoints'

export class ScreeningDocumentsApi {
  constructor(private axios: AxiosService) {}

  getScreeningDocuments = async (params?: IGetScreeningDocumentsParams) => {
    const response = await this.axios.get<IPayload<IScreeningDocument[]>>(
      Endpoints.getScreeningDocuments,
      params
    )
    return response
  }

  postScreeningDocument = async (params: IPostScreeningDocumentParams) => {
    const response = await this.axios.post<IPayload<IScreeningDocument>>(
      Endpoints.postScreeningDocument,
      params
    )
    return response
  }

  putScreeningDocument = async (id: number, params?: IPutScreeningDocumentParams) => {
    const response = await this.axios.put<IPayload<IScreeningDocument>>(
      Endpoints.putScreeningDocument(id),
      params
    )
    return response
  }
}
